module.exports = __webpack_public_path__ + "static/media/promo.630ce738.png";